import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { WhoWeServe } from "@/components/landing/WhoWeServe";
import { Purpose } from "@/components/landing/Purpose";
import { Pillars } from "@/components/landing/Pillars";
import { HowWeWork } from "@/components/landing/HowWeWork";
import { TrackRecord } from "@/components/landing/TrackRecord";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (hash.length > 1 && document.querySelector(hash)) {
        e.preventDefault();
        lenis.scrollTo(hash, { offset: -88 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="font-body bg-[#FBFAF6] text-[#3C3C3B] antialiased">
      <Header />
      <main>
        <Hero />
        <WhoWeServe />
        <Purpose />
        <Pillars />
        <HowWeWork />
        <TrackRecord />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
